import { render, staticRenderFns } from "./AuthorityMessage.vue?vue&type=template&id=528480a0"
import script from "./AuthorityMessage.vue?vue&type=script&lang=js"
export * from "./AuthorityMessage.vue?vue&type=script&lang=js"
import style0 from "./AuthorityMessage.vue?vue&type=style&index=0&id=528480a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports